var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPointShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm0 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1zm0 .667a6.333 6.333 0 1 1 0 12.666A6.333 6.333 0 0 1 8 1.667zm1.33 4.855c.507.047 1.014.075 1.53.112.348.037.865.055.997.454.131.4-.273.724-.536.946-.394.334-.78.65-1.174.984l.366 1.465c.075.334.207.835-.131 1.076-.348.241-.78-.028-1.08-.213-.433-.26-.865-.529-1.297-.789-.442.26-.874.538-1.316.798-.3.176-.732.464-1.07.214-.348-.242-.207-.743-.132-1.076l.366-1.475c-.385-.334-.78-.65-1.174-.984-.263-.231-.667-.547-.536-.946.132-.399.649-.426.996-.454.517-.037 1.024-.065 1.532-.112.197-.463.385-.927.582-1.39.141-.326.329-.799.752-.799.413 0 .601.473.742.798.197.464.385.928.582 1.391z",
    id: "a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#475B7F",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.828 9.179h-16a8 8 0 0 1 16 0z",
    fillOpacity: 0.24,
    fill: "#FFF",
    mask: "url(#b)",
    transform: "rotate(45 10.828 5.179)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointShield);
export default __webpack_public_path__ + "static/media/point-shield.a8d7cd6e.svg";
export { ForwardRef as ReactComponent };